import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environments';
import { PaymentPlanResponse } from '../models/responses/payment-plan-response';
import { CreateProductRequest } from '../models/requests/create-product-request';

@Injectable({
  providedIn: 'root'
})
export class RebillingService {

  constructor(private httpClient: HttpClient) { }

  createStripeConnectUrl() {
    return this.httpClient.get<{ url: string }>(`${environment.rebillingUrl}/connectRebillingAccount`);
  }
  fetchPaymentPlans(mainAccountId: number) {
    return this.httpClient.get<PaymentPlanResponse[]>(`${environment.rebillingUrl}/fetchPlans/${mainAccountId}`);
  }

  createProduct(request:CreateProductRequest) {
    return this.httpClient.post<PaymentPlanResponse[]>(`${environment.rebillingUrl}/createProduct`,request);
  }
}
